/** Istilah operasional delman — konsisten di PWA Delman. */
export const delmanTerms = {
  appName: 'Superoti Delman',
  modules: {
    trip: 'Sesi kirim',
    kitchenTransfer: 'Antar dapur',
    handover: 'QR handover',
    pickup: 'Pickup retur',
    attendance: 'Absensi',
  },
  auth: {
    flowSteps: ['Aktivasi', 'Login PIN'] as const,
  },
  login: {
    step: 'Langkah 2 dari 2',
    title: 'Login PIN',
    subtitle: 'PIN pribadi delman — 6 digit untuk mulai sesi kirim.',
    helper: 'Isi 6 digit PIN untuk lanjut.',
    submit: 'Masuk',
    submitting: 'Memverifikasi…',
    switchDevice: 'Ganti device',
  },
  trip: {
    start: 'Mulai sesi kirim',
    complete: 'Selesai sesi kirim',
    whatIsTrip:
      'Sesi kirim = satu putaran keluar dapur: antar ke beberapa toko, pantau penerimaan, pickup retur, lalu tutup sesi. Satu hari bisa beberapa sesi.',
    inProgress: 'Berjalan',
    ready: 'Siap berangkat',
    completed: 'Selesai',
    itinerary: 'Pilih toko',
    preStartHint:
      'Pilih toko untuk mulai sesi. Setelah berjalan, tap toko untuk detail kiriman dan handover QR.',
    emptyStops: 'Belum ada pengiriman untuk sesi ini. Minta dapur menyerahkan barang ke delman.',
    waitingNextDispatch:
      'Belum ada perintah kirim berikutnya. Minta dapur menyerahkan barang untuk sesi berikutnya.',
    storePickerHint: 'Tap toko untuk handover QR atau lihat status.',
    storePickerReadyHint: 'Tap toko untuk mulai sesi kirim.',
    summaryStripReady: 'Tap toko untuk mulai sesi kirim',
    summaryStartedFrom: (storeName: string, done: number, total: number) =>
      `Dimulai dari ${storeName} · ${done}/${total} toko selesai`,
    storeStartedHere: 'Sesi dimulai di sini',
    storeInProgress: 'Sedang dikerjakan',
    completeChecklistTitle: 'Syarat tutup sesi kirim',
    completeCheckDelivery: (done: number, total: number) => `${done}/${total} toko selesai terima`,
    completeCheckReturns: (picked: number, waiting: number) =>
      waiting > 0 ? `${picked} di-pickup · ${waiting} menunggu` : `${picked} retur di-pickup`,
    completeCheckReturnsAction: 'Ke scan retur',
    attendanceRequired: 'Check-in absensi dulu sebelum mulai sesi kirim.',
    attendanceRequiredBanner: 'Belum check-in hari ini — absen dulu sebelum mulai sesi kirim.',
    attendanceRequiredAction: 'Ke absensi',
    yesterdayTripTitle: 'Sesi kemarin',
    yesterdayTripSummary: (id: string, stops: number) => `${id} · ${stops} toko · selesai`,
    sessionHistoryTitle: 'Sesi selesai hari ini',
    sessionHistoryItem: (sessionNo: number, stops: number) => `Sesi ${sessionNo} · ${stops} toko · selesai`,
    betweenSessionsHint:
      'Sesi kirim selesai. Tetap status masuk — tunggu perintah berikutnya dari dapur. Tidak perlu check-out istirahat.',
    storeActionStartTrip: 'Tap untuk mulai sesi kirim',
    storeActionViewDetail: 'Lihat detail kiriman',
    storeActionMonitor: 'Pantau penerimaan',
    storeActionSummary: 'Lihat ringkasan',
    startConfirmWithStore: (storeName: string) =>
      `Mulai sesi kirim menuju ${storeName}. Pastikan barang sudah di kendaraan sebelum berangkat.`,
    completeHint: 'Selesaikan semua pengiriman dan pickup retur sebelum menutup sesi kirim.',
    completeBlockedDelivery: 'Masih ada toko yang belum selesai menerima barang.',
    completeBlockedReturn: 'Masih ada retur belum di-pickup.',
    completeSummaryTitle: 'Ringkasan sebelum tutup sesi',
    closedTitle: 'Sesi kirim selesai.',
    closedRemainder: (qty: number) => `Sisa in transit: ${qty} pcs → area retur dapur`,
    closedFooter: 'Dapur akan melakukan penerimaan retur fisik.',
    checkoutPromptTitle: 'Saat pulang, check-out absensi',
    checkoutPromptBody: 'Check-out hanya saat pulang — tidak perlu antar sesi kirim.',
    checkoutPromptAction: 'Ke absensi',
    returnBanner: (count: number) => `${count} retur menunggu scan pickup`,
    returnBannerAction: 'Buka scan QR retur toko',
    starting: 'Memulai…',
    progress: (done: number, total: number) => `${done}/${total} toko selesai`,
    startConfirmTitle: 'Mulai sesi kirim?',
    startConfirmBody: 'Pastikan barang sudah di kendaraan sebelum berangkat.',
    startConfirmPrimary: 'Ya, mulai sesi kirim',
    completeSheetTitle: 'Selesai sesi kirim',
    completeSheetDelivery: 'Pengiriman selesai',
    completeSheetReturns: 'Retur di-pickup',
    completeSheetTransit: 'Sisa in transit',
    completeSheetTransitHint: '→ Area retur dapur',
    completeSheetPrimary: 'Lanjut — masukkan PIN',
    completeSheetMockTransit: (qty: number) => `${qty} pcs (estimasi)`,
    startedToast: (storeName: string) => `Sesi kirim dimulai — ${storeName}.`,
    completedToast: (qty: number) => `Sesi kirim selesai. Sisa ${qty} pcs ke area retur dapur.`,
  },
  kitchenTransfer: {
    empty: 'Belum ada kiriman antar dapur hari ini. Tunggu dapur asal serahkan barang ke delman.',
    dropAction: 'Tap untuk QR dapur tujuan',
    dropPending: 'Belum selesai',
    dropDone: 'Sudah diterima',
    dropScanned: 'Sudah discan dapur',
    handoverHint: 'Tampilkan QR agar kepala dapur tujuan bisa scan di tablet PWA.',
    handoverDone: 'Dapur tujuan sudah menyelesaikan penerimaan.',
    handoverScanned: 'QR sudah discan dapur tujuan. Menunggu konfirmasi PIN penerimaan.',
    expiryLabel: (time: string) => `Kedaluwarsa ${time}`,
  },
  delivery: {
    showQr: 'Tampilkan QR handover',
    receivingStatus: 'Status penerimaan toko',
    readOnly: 'Delman tidak mengubah qty — hanya pantau progress toko.',
    notFound: 'Pengiriman tidak ditemukan.',
    backToTrip: 'Kembali ke sesi kirim',
    totalShipped: (qty: number) => `Total kirim: ${qty} pcs`,
    completedBanner: 'Toko sudah menyelesaikan penerimaan.',
    damagedNote: 'Damaged/shortage hanya diisi toko — delman pantau saja.',
    receivingDraft: 'Draft (toko sedang input)',
    receivingWaiting: 'Menunggu scan toko',
    receivingNone: 'Belum dimulai',
  },
  handover: {
    title: 'QR handover',
    subtitle: 'Tampilkan QR ke kasir toko untuk scan penerimaan barang.',
    create: 'Buat QR handover',
    refresh: 'Perbarui QR',
    loading: 'Membuat QR…',
    expiredTitle: 'QR kedaluwarsa',
    expiredHint: 'Buat ulang sebelum toko scan.',
    storeDraft: 'Toko sedang input penerimaan.',
    waitingScan: 'Menunggu toko scan QR…',
    storeScannedToast: (storeName: string) => `${storeName} scan QR — receiving draft dibuat.`,
    storeCompletedToast: (storeName: string) => `${storeName} selesai terima barang.`,
    ttlExpired: 'Kedaluwarsa — regenerate QR',
    ttlRemaining: (min: number, sec: string) => `Berlaku ${min}:${sec}`,
    fullscreen: 'Layar penuh',
    fullscreenClose: 'Tutup layar penuh',
    regenerate: 'Buat ulang QR',
  },
  returnPickup: {
    scan: 'Scan QR retur toko',
    confirm: 'Konfirmasi pickup',
    intro: 'Toko tampilkan QR retur → delman scan → konfirmasi PIN.',
    cameraHint: 'Arahkan kamera ke QR retur dari App Toko',
    cameraUnsupported: 'Kamera QR tidak didukung di browser ini — tempel kode manual di bawah.',
    cameraPermissionDenied: 'Izinkan akses kamera di pengaturan browser untuk scan QR.',
    tripNotStarted: 'Mulai sesi kirim dulu sebelum pickup retur.',
    scanned: (code: string) => `QR terbaca: ${code}`,
    cameraInactiveTrip: 'Mulai sesi kirim dulu — kamera scan akan aktif otomatis.',
    manualToggle: 'Input manual kode QR',
    pasteLabel: 'Tempel kode QR retur',
    pastePlaceholder: 'SUPEROTI:RP:<return_id>:<token>',
    pendingTitle: (count: number) => `Menunggu pickup (${count})`,
    pickedTitle: 'Sudah di-pickup',
    backToTrip: 'Kembali ke sesi kirim',
    emptyScan: 'Masukkan atau scan kode QR retur.',
    unknownQr: 'QR retur tidak dikenali atau sudah di-pickup.',
    pinTitle: 'PIN konfirmasi pickup',
    pinDescription: (id: string, items: number, store: string) =>
      `Konfirmasi pickup ${id} · ${items} item dari ${store}.`,
    successToast: 'Retur berhasil di-pickup.',
  },
  sync: {
    queued: 'Tersimpan di HP — akan disinkronkan saat online',
    offline: 'Offline',
    online: 'Online',
    pending: (count: number) => `${count} antrean`,
    flushing: 'Menyinkronkan…',
    tapToRetry: 'Ketuk untuk coba sinkronkan ulang',
    statusTitle: 'Status koneksi HP delman',
    offlineBanner: 'Tidak ada internet',
    offlineBannerDetail: 'Data tetap aman di HP. Akan terkirim otomatis saat online.',
    offlinePending: (count: number) => `${count} operasi menunggu sinkron`,
  },
  pwa: {
    installTitle: 'Pasang aplikasi di HP',
    installBody: 'Akses sesi kirim lebih cepat dari layar utama — tanpa buka browser.',
    installAction: 'Install',
    installDismiss: 'Nanti',
  },
  attendance: {
    selfOnlyHint: 'Absensi pribadi — hanya untuk akun delman di HP ini.',
    statusToday: 'Status hari ini',
    shift: 'Shift',
    checkIn: 'Check-in',
    checkOut: 'Check-out',
    checkInVerb: 'masuk',
    checkOutVerb: 'keluar',
    notYet: 'Belum check-in',
    onShift: 'Sedang shift',
    finished: 'Selesai hari ini',
    selfiePinRequired: 'Selfie + PIN wajib',
    selfieTitle: (action: string) => `${action} — ambil selfie`,
    confirmHint: 'Pastikan foto sudah benar sebelum PIN.',
    pinTitle: (action: string) => `Konfirmasi ${action}`,
    pinDescription: (name: string, action: string) => `PIN ${name} untuk ${action}.`,
    submit: 'Submit absensi',
    onTime: 'Tepat waktu',
    late: 'Terlambat',
    duration: (label: string) => `Durasi shift: ${label}`,
    offlineNote: 'Tanpa internet? Absensi dan foto tetap tersimpan di HP, lalu terkirim saat online.',
    stayOnShiftHint:
      'Antar sesi kirim, tetap status masuk. Check-out hanya saat pulang — tidak perlu check-out istirahat.',
    tripNotCompleted:
      'Masih ada sesi kirim yang aktif. Selesaikan semua pengiriman dan tutup sesi dulu sebelum check-out.',
    tripNotCompletedAction: 'Ke sesi kirim',
  },
  activation: {
    step: 'Langkah 1 dari 2',
    title: 'Aktivasi HP delman',
    subtitle: 'Masukkan kode sekali pakai dari Admin HO.',
    hint: 'Kode berlaku 24 jam · HP ini terikat ke satu delman.',
    codeHelper: 'Ketik atau tempel kode 6 karakter dari Admin HO.',
    codeValid: 'Kode valid — periksa data sebelum aktivasi.',
    previewTitle: 'Konfirmasi binding',
    alreadyBoundTitle: 'HP sudah teraktivasi',
    alreadyBoundAction: 'Lanjut login PIN',
    rebindAction: 'Aktivasi ulang',
    footer: 'Belum punya kode? Hubungi Admin HO.',
    wrongDeviceType: 'Kode ini bukan untuk HP delman.',
  },
} as const
